import { EventService } from '@geovelo-frontends/commons';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import { AppContext } from '../../app/context';
import { environment } from '../../environment';
import LeaderboardLayout from '../../layouts/leaderboard';
import { companySiteEntity } from '../../models/entities';

function CompanyLeaderboard(): React.JSX.Element {
  const [initialized, setInitialized] = useState(false);
  const [geogroup, setGeogroup] = useState<{ id: number; title: string }>();
  const {
    event: { config },
    premiumGeogroups,
  } = useContext(AppContext);
  const { groupId: _groupId } = useParams<{ groupId?: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (premiumGeogroups) setInitialized(true);
  }, [premiumGeogroups]);

  useEffect(() => {
    if (initialized) {
      if (_groupId) getGeogroup(parseInt(_groupId));
      else navigate('/classements/employeurs');
    }
  }, [initialized]);

  async function getGeogroup(geoGroupId: number) {
    if (!premiumGeogroups) return;

    try {
      if (Number.isNaN(geoGroupId)) throw new Error('invalid path param');
      if (!premiumGeogroups[geoGroupId]) throw new Error('company not customer');

      const { items } = await EventService.getRanking(
        config === 'mdv' ? environment.mdvEventId : environment.eventId,
        {
          page: 1,
          pageSize: 1,
          groupTypes: ['company'],
          onlyParentGroups: true,
          groupsIds: [geoGroupId],
        },
      );

      if (!items[0]) throw new Error('unknown company');

      const { id, title } = items[0];

      setGeogroup({ id, title });
    } catch (err) {
      console.error(err);
      navigate('/classements/employeurs');
    }
  }

  return (
    <LeaderboardLayout
      description="Retrouvez le classement des sites d'une entreprise."
      entity={companySiteEntity}
      parent={geogroup}
      title={`Classement des sites | Challenges ${
        config === 'mdv' ? 'Mois du vélo' : 'Mai à vélo'
      } par Geovelo`}
    />
  );
}

export default CompanyLeaderboard;
